//tODO : change the name of "data" module to something that makes more sense
import { APIService } from "@/common/api.service";
import { dropdownOptions } from "./functions.module";
import {
  //Application Configuration Routes
  CREATE_ACCOUNT,
  GET_ACCOUNT,
  UPDATE_ACCOUNT,
  DELETE_ACCOUNT,
  CREATE_ACCOUNT_GROUP,
  GET_ACCOUNT_GROUP,
  UPDATE_ACCOUNT_GROUP,
  DELETE_ACCOUNT_GROUP,
  GET_BADGE,
  GET_USER_BADGE,
  CREATE_BADGE,
  UPDATE_BADGE,
  DELETE_BADGE,
  GET_BAND,
  CREATE_BAND,
  UPDATE_BAND,
  DELETE_BAND,
  GET_COMMENT_TYPE,
  GET_DEGREE_LEVEL,
  CREATE_DEGREE_LEVEL,
  UPDATE_DEGREE_LEVEL,
  DELETE_DEGREE_LEVEL,
  GET_EXPERIENCE_LEVEL,
  CREATE_EXPERIENCE_LEVEL,
  UPDATE_EXPERIENCE_LEVEL,
  DELETE_EXPERIENCE_LEVEL,
  GET_GROWTH_PLATFORM,
  CREATE_GROWTH_PLATFORM,
  UPDATE_GROWTH_PLATFORM,
  DELETE_GROWTH_PLATFORM,
  GET_JOB_ROLE_SPECIALTIES,
  // UPDATE_JRSS,
  // DELETE_JRSS,
  // CREATE_JRSS,
  GET_LOCATION,
  CREATE_LOCATION,
  UPDATE_LOCATION,
  DELETE_LOCATION,
  GET_PRACTICE,
  CREATE_PRACTICE,
  UPDATE_PRACTICE,
  DELETE_PRACTICE,
  GET_PRONOUN,
  CREATE_PRONOUN,
  UPDATE_PRONOUN,
  DELETE_PRONOUN,
  GET_SECTOR,
  CREATE_SECTOR,
  UPDATE_SECTOR,
  DELETE_SECTOR,
  GET_SKILL,
  CREATE_SKILL,
  UPDATE_SKILL,
  DELETE_SKILL,
  GET_TECH_SKILL,
  GET_SOFT_SKILL,

  // Application Permissions Data
  GET_ROLE,
  CREATE_ROLE,
  UPDATE_ROLE,
  DELETE_ROLE,
  GET_PERMISSION,
  CREATE_PERMISSION,
  UPDATE_PERMISSION,
  DELETE_PERMISSION,
  GET_PERMISSION_GROUPS,
  GET_PERMISSION_GROUPS_DETAIL,
  CREATE_PERMISSION_GROUPS,
  UPDATE_PERMISSION_GROUPS,
  GET_CV_REVIEWER_OPEN_SEATS,
  //---------------------------------> May need to be sourced using SQL Queries
  GET_USER_ROLE,
  CREATE_USER_ROLE,
  UPDATE_USER_ROLE,
  DELETE_USER_ROLE,
  GET_ROLE_PERMISSION,
  CREATE_ROLE_PERMISSION,
  UPDATE_ROLE_PERMISSION,
  DELETE_ROLE_PERMISSION,
  //---------------------------------> May need to be sourced using SQL Queries

  // Support
  UPLOAD_BUG_IMAGE,
  GET_SUPPORT,
  GET_SUPPORT_DETAIL,
  CREATE_SUPPORT_FEEDBACK,
  CREATE_SUPPORT_BUG,
  CREATE_SUPPORT_DATA_ACCESS,
  UPDATE_SUPPORT,
  DELETE_SUPPORT,
  GET_SUPPORT_TYPE,

  //@To-do Need to make separate queries for each of the STAUSES.
} from "./actions.type";
import {
  SET_TIMING_OUT,
  SET_GREY_SCALE,
  SET_CLIENT_CONFIG,
  SET_ANONYMOUS,
  //Config
  SET_ACCOUNT,
  SET_ACCOUNT_GROUP,
  SET_BADGE,
  SET_USER_BADGE,
  SET_BAND,
  SET_PENPIC_CLIENT,
  SET_COMMENT_TYPE,
  SET_DEGREE_LEVEL,
  SET_EXPERIENCE_LEVEL,
  SET_GROWTH_PLATFORM,
  SET_JOB_ROLE_SPECIALTIES,
  SET_LOCATION,
  SET_PRACTICE,
  SET_PRONOUN,
  SET_SECTOR,
  SET_SKILL,
  SET_SOFT_SKILL,
  SET_TECH_SKILL,
  SET_FILTER,

  //Admin
  SET_ROLE,
  SET_CV_REVIEWER_OPEN_SEATS,
  SET_USER_ROLE,
  SET_ROLE_PERMISSION,
  SET_PERMISSION,
  SET_SUPPORT,
  SET_SUPPORT_DETAIL,
  SET_SUPPORT_TYPE,
  SET_LOADING,
  SET_PERMISSION_GROUPS,
  SET_PERMISSION_GROUPS_DETAIL,
  SET_EDITMODE,
} from "./mutations.type";

const state = {
  // Timer for timing out tokens
  timing_out: [],
  //config data
  account: [],
  account_group: [],
  badge: [],
  user_badge: [],
  bands: [],
  comment_types: [],
  degree_level: [],
  experienceLevel: [],
  filter: [],

  growth_platform: [],
  job_role_specialties: [],
  location: [],
  practice: [],
  pronoun: [],
  sector: [],
  skill: [],
  techSkill: [],
  softSkill: [],

  //Admin
  user_role: [],
  cv_reviewer_open_seats: [],
  role: [],
  permission: [],
  role_permission: [],
  greyScale: false,
  clientConfig: false,
  anonymous: false,
  penpicClient: {},
  loading: false,
  support: [],
  support_detail: [],
  support_types: [],
  permission_groups: [],
  permission_groups_detail: [],
  editmode: false,
};

const getters = {
  timing_out(state) {
    return state.timing_out;
  },
  editmode(state) {
    return state.editmode;
  },
  //Config
  account(state) {
    return dropdownOptions(state.account);
  },
  account_group(state) {
    return dropdownOptions(state.account_group);
  },
  badge(state) {
    return dropdownOptions(state.badge);
  },
  user_badge(state) {
    return state.user_badge;
  },
  band(state) {
    return state.bands
      .map((option) => {
        return {
          id: String(option.id),
          value: String(option.id),
          name: String(option.name),
          label: String(option.name),
          band_group: String(option.band_group),
          code: option.code ? String(option.code) : "",
        };
      })
      .sort((previous, current) => {
        if (previous.name > current.name) {
          return 1;
        } else {
          return -1;
        }
      });
  },

  penpicClient(state) {
    return state.penpicClient;
  },
  comment_types(state) {
    return dropdownOptions(state.comment_types);
  },
  degree_level(state) {
    return dropdownOptions(state.degree_level);
  },
  experienceLevel(state) {
    return dropdownOptions(state.experienceLevel);
  },
  filter(state) {
    return state.filter;
  },
  growth_platform(state) {
    return dropdownOptions(state.growth_platform);
  },
  job_role_specialties(state) {
    return dropdownOptions(state.job_role_specialties);
  },
  location(state) {
    return dropdownOptions(state.location);
  },
  practice(state) {
    return dropdownOptions(state.practice);
  },
  pronoun(state) {
    return dropdownOptions(state.pronoun);
  },
  sector(state) {
    return dropdownOptions(state.sector);
  },
  skill(state) {
    return dropdownOptions(state.skill);
  },
  techSkill(state) {
    for (let i of state.techSkill) {
      i.value = String(i.id);
      i.label = i.name;
    }
    return state.techSkill;
  },
  softSkill(state) {
    for (let i of state.softSkill) {
      i.value = String(i.id);
      i.label = i.name;
    }
    return state.softSkill;
  },
  role(state) {
    return dropdownOptions(state.role);
  },
  role_permission(state) {
    return dropdownOptions(state.role_permission);
  },
  user_role(state) {
    return dropdownOptions(state.user_role);
  },
  cv_reviewer_open_seats(state) {
    return state.cv_reviewer_open_seats;
  },
  permission(state) {
    return dropdownOptions(state.permission);
  },
  support(state) {
    return state.support;
  },
  support_detail(state) {
    return state.support_detail;
  },
  support_types(state) {
    return dropdownOptions(state.support_types);
  },
  loading(state) {
    return state.loading;
  },
  greyScale(state) {
    return state.greyScale;
  },
  clientConfig(state) {
    return state.clientConfig;
  },
  anonymous(state) {
    return state.anonymous;
  },
  permission_groups(state) {
    return dropdownOptions(state.permission_groups);
  },
  permission_groups_detail(state) {
    return state.permission_groups_detail;
  },
};

const actions = {
  async [GET_ACCOUNT](context, attributes) {
    try {
      const { data } = await APIService.query("/v3/accounts", attributes);
      context.commit(SET_ACCOUNT, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [UPDATE_ACCOUNT](context, payload) {
    try {
      await APIService.update("/v3/accounts", payload.id, payload.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [DELETE_ACCOUNT](context, id) {
    try {
      await APIService.delete("/v3/accounts", id);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [CREATE_ACCOUNT](context, data) {
    try {
      await APIService.post("/v3/accounts", data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_ACCOUNT_GROUP](context, attributes) {
    try {
      const { data } = await APIService.query("/v3/account_groups", attributes);
      context.commit(SET_ACCOUNT_GROUP, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [UPDATE_ACCOUNT_GROUP](context, payload) {
    try {
      await APIService.update("/v3/account_groups", payload.id, payload.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [DELETE_ACCOUNT_GROUP](context, id) {
    try {
      await APIService.delete("/v3/account_groups", id);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [CREATE_ACCOUNT_GROUP](context, data) {
    try {
      await APIService.post("/v3/account_groups", data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_BADGE](context, attributes) {
    try {
      const { data } = await APIService.query("/v3/badges", attributes);
      context.commit(SET_BADGE, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_USER_BADGE](context, param) {
    try {
      const { data } = await APIService.get("/v3/user_badges", param);
      context.commit(SET_USER_BADGE, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },

  async [UPDATE_BADGE](context, payload) {
    try {
      await APIService.update("/v3/badges", payload.id, payload.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [DELETE_BADGE](context, id) {
    try {
      await APIService.delete("/v3/badges", id);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [CREATE_BADGE](context, data) {
    try {
      await APIService.post("/v3/badges", data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_BAND](context, attributes) {
    try {
      const { data } = await APIService.query("/v3/bands", attributes);
      context.commit(SET_BAND, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [UPDATE_BAND](context, payload) {
    try {
      await APIService.update("/v3/bands", payload.id, payload.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [DELETE_BAND](context, id) {
    try {
      await APIService.delete("/v3/bands", id);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [CREATE_BAND](context, data) {
    try {
      await APIService.post("/v3/bands", data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_COMMENT_TYPE](context, attributes) {
    try {
      const { data } = await APIService.query("/v3/comment_types", attributes);
      context.commit(SET_COMMENT_TYPE, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_DEGREE_LEVEL](context, attributes) {
    try {
      const { data } = await APIService.query("/v3/degree_levels", attributes);
      context.commit(SET_DEGREE_LEVEL, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [UPDATE_DEGREE_LEVEL](context, payload) {
    try {
      await APIService.update("/v3/degree_levels", payload.id, payload.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [DELETE_DEGREE_LEVEL](context, id) {
    try {
      await APIService.delete("/v3/degree_levels", id);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [CREATE_DEGREE_LEVEL](context, data) {
    try {
      await APIService.post("/v3/degree_levels", data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_EXPERIENCE_LEVEL](context, attributes) {
    try {
      const { data } = await APIService.query(
        "/v3/experience_levels",
        attributes
      );
      context.commit(SET_EXPERIENCE_LEVEL, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [UPDATE_EXPERIENCE_LEVEL](context, payload) {
    try {
      await APIService.update(
        "/v3/experience_levels",
        payload.id,
        payload.data
      );
    } catch (error) {
      throw new Error(error);
    }
  },
  async [DELETE_EXPERIENCE_LEVEL](context, id) {
    try {
      await APIService.delete("/v3/experience_levels", id);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [CREATE_EXPERIENCE_LEVEL](context, data) {
    try {
      await APIService.post("/v3/experience_levels", data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_GROWTH_PLATFORM](context, attributes) {
    try {
      const { data } = await APIService.query(
        "/v3/growth_platforms",
        attributes
      );
      context.commit(SET_GROWTH_PLATFORM, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [UPDATE_GROWTH_PLATFORM](context, payload) {
    try {
      await APIService.update("/v3/growth_platforms", payload.id, payload.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [DELETE_GROWTH_PLATFORM](context, id) {
    try {
      await APIService.delete("/v3/growth_platforms", id);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [CREATE_GROWTH_PLATFORM](context, data) {
    try {
      await APIService.post("/v3/growth_platforms", data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_JOB_ROLE_SPECIALTIES](context, attributes) {
    try {
      const { data } = await APIService.query(
        "/v3/job_role_specialties",
        attributes
      );
      context.commit(SET_JOB_ROLE_SPECIALTIES, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },
  // async [CREATE_JRSS](context, data) {
  //   try {
  //     await APIService.post("/v3/jrss", data);
  //   } catch (error) {
  //     throw new Error(error);
  //   }
  // },
  // async [UPDATE_JRSS](context, payload) {
  //   try {
  //     await APIService.update("/v3/jrss", payload.id, payload.data);
  //   } catch (error) {
  //     throw new Error(error);
  //   }
  // },
  // async [DELETE_JRSS](context, id) {
  //   try {
  //     await APIService.delete("/v3/jrss", id);
  //   } catch (error) {
  //     throw new Error(error);
  //   }
  // },
  async [GET_LOCATION](context, attributes) {
    try {
      const { data } = await APIService.query("/v3/locations", attributes);
      context.commit(SET_LOCATION, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [UPDATE_LOCATION](context, payload) {
    try {
      await APIService.update("/v3/locations", payload.id, payload.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [DELETE_LOCATION](context, id) {
    try {
      await APIService.delete("/v3/locations", id);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [CREATE_LOCATION](context, data) {
    try {
      await APIService.post("/v3/locations", data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_PRACTICE](context, attributes) {
    try {
      const { data } = await APIService.query("/v3/practices", attributes);
      context.commit(SET_PRACTICE, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },

  async [UPDATE_PRACTICE](context, payload) {
    try {
      await APIService.update("/v3/practices", payload.id, payload.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [DELETE_PRACTICE](context, id) {
    try {
      await APIService.delete("/v3/practices", id);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [CREATE_PRACTICE](context, data) {
    try {
      await APIService.post("/v3/practices", data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_PRONOUN](context, attributes) {
    try {
      const { data } = await APIService.query("/v3/pronouns", attributes);
      context.commit(SET_PRONOUN, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [UPDATE_PRONOUN](context, payload) {
    try {
      await APIService.update("/v3/pronouns", payload.id, payload.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [DELETE_PRONOUN](context, id) {
    try {
      await APIService.delete("/v3/pronouns", id);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [CREATE_PRONOUN](context, data) {
    try {
      await APIService.post("/v3/pronouns", data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_SECTOR](context, attributes) {
    try {
      const { data } = await APIService.query("/v3/sectors", attributes);
      context.commit(SET_SECTOR, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [UPDATE_SECTOR](context, payload) {
    try {
      await APIService.update("/v3/sectors", payload.id, payload.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [DELETE_SECTOR](context, id) {
    try {
      await APIService.delete("/v3/sectors", id);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [CREATE_SECTOR](context, data) {
    try {
      await APIService.post("/v3/sectors", data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_TECH_SKILL](context, attributes) {
    try {
      const { data } = await APIService.query("/v3/skills", attributes);
      context.commit(SET_TECH_SKILL, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_SOFT_SKILL](context, attributes) {
    try {
      const { data } = await APIService.query("/v3/skills", attributes);
      context.commit(SET_SOFT_SKILL, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_SKILL](context, attributes) {
    try {
      const { data } = await APIService.query("/v3/skills", attributes);
      context.commit(SET_SKILL, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [CREATE_SKILL](context, data) {
    try {
      await APIService.post("/v3/skills", data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [UPDATE_SKILL](context, payload) {
    try {
      await APIService.update("/v3/skills", payload.id, payload.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [DELETE_SKILL](context, id) {
    try {
      await APIService.delete("/v3/skills", id);
    } catch (error) {
      throw new Error(error);
    }
  },

  async [GET_ROLE](context, attributes) {
    try {
      const { data } = await APIService.query("/v3/roles", attributes);
      context.commit(SET_ROLE, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [UPDATE_ROLE](context, payload) {
    try {
      await APIService.update("/v3/roles", payload.id, payload.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [DELETE_ROLE](context, id) {
    try {
      await APIService.delete("/v3/roles", id);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [CREATE_ROLE](context, data) {
    try {
      await APIService.post("/v3/roles", data);
    } catch (error) {
      throw new Error(error);
    }
  },

  async [GET_USER_ROLE](context, attributes) {
    try {
      const { data } = await APIService.query("/v3/user_roles", attributes);
      context.commit(SET_USER_ROLE, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_CV_REVIEWER_OPEN_SEATS](context, id) {
    try {
      const { data } = await APIService.get("/v3/cv_reviewer_open_seats", id);
      context.commit(SET_CV_REVIEWER_OPEN_SEATS, data.openSeats);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [CREATE_USER_ROLE](context, data) {
    try {
      await APIService.post("/v3/user_roles", data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [UPDATE_USER_ROLE](context, payload) {
    try {
      await APIService.update("/v3/user_roles", payload.id, payload.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [DELETE_USER_ROLE](context, id) {
    try {
      await APIService.delete("/v3/user_roles", id);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_PERMISSION_GROUPS](context, attributes) {
    try {
      const { data } = await APIService.query(
        "v3/permission_groups",
        attributes
      );
      context.commit(SET_PERMISSION_GROUPS, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_PERMISSION_GROUPS_DETAIL](context, id) {
    try {
      const { data } = await APIService.get("v3/permission_groups", id);
      context.commit(SET_PERMISSION_GROUPS_DETAIL, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [UPDATE_PERMISSION_GROUPS](context, payload) {
    try {
      await APIService.update("v3/permission_groups", payload.id, payload.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [CREATE_PERMISSION_GROUPS](context, data) {
    try {
      await APIService.post("/v3/permission_groups", data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_PERMISSION](context, attributes) {
    try {
      const { data } = await APIService.query("/v3/permissions", attributes);
      context.commit(SET_PERMISSION, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [UPDATE_PERMISSION](context, payload) {
    try {
      await APIService.update("/v3/permissions", payload.id, payload.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [DELETE_PERMISSION](context, id) {
    try {
      await APIService.delete("/v3/permissions", id);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [CREATE_PERMISSION](context, data) {
    try {
      await APIService.post("/v3/permissions", data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_ROLE_PERMISSION](context, attributes) {
    try {
      const { data } = await APIService.query(
        "/v3/role_permissions",
        attributes
      );
      context.commit(SET_ROLE_PERMISSION, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [UPDATE_ROLE_PERMISSION](context, payload) {
    try {
      await APIService.update("/v3/role_permissions", payload.id, payload.data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [DELETE_ROLE_PERMISSION](context, id) {
    try {
      await APIService.delete("/v3/role_permissions", id);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [CREATE_ROLE_PERMISSION](context, data) {
    try {
      await APIService.post("/v3/role_permissions", data);
    } catch (error) {
      throw new Error(error);
    }
  },

  async [GET_SUPPORT](context, attributes) {
    try {
      const { data } = await APIService.query("/v3/supports", attributes);
      context.commit(SET_SUPPORT, data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_SUPPORT_DETAIL](context, id) {
    try {
      const { data } = await APIService.get("/v3/supports", id);
      context.commit(SET_SUPPORT_DETAIL, data.support);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [CREATE_SUPPORT_FEEDBACK](context, data) {
    try {
      await APIService.post("/v3/supports_feedback", data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [CREATE_SUPPORT_BUG](context, data) {
    try {
      await APIService.post("/v3/supports_bug", data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [CREATE_SUPPORT_DATA_ACCESS](context, data) {
    try {
      await APIService.post("/v3/supports_data_access", data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [UPDATE_SUPPORT](context, payload) {
    try {
      await APIService.update(
        "/v3/supports_feedback",
        payload.id,
        payload.data
      );
    } catch (error) {
      throw new Error(error);
    }
  },
  async [DELETE_SUPPORT](context, id) {
    try {
      await APIService.update("/v3/delete_support", id);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [UPLOAD_BUG_IMAGE](context, data) {
    try {
      await APIService.post("/v3/upload_bug_image", data);
    } catch (error) {
      throw new Error(error);
    }
  },
  async [GET_SUPPORT_TYPE](context, attributes) {
    try {
      const { data } = await APIService.query("/v3/support_types", attributes);
      context.commit(SET_SUPPORT_TYPE, data.rows);
    } catch (error) {
      throw new Error(error);
    }
  },
};

const mutations = {
  [SET_ACCOUNT](state, account) {
    state.account = account;
  },
  [SET_ACCOUNT_GROUP](state, account_group) {
    state.account_group = account_group;
  },
  [SET_BADGE](state, badge) {
    state.badge = badge;
  },
  [SET_USER_BADGE](state, user_badge) {
    state.user_badge = user_badge;
  },
  [SET_BAND](state, band) {
    state.bands = band;
  },
  [SET_COMMENT_TYPE](state, comment_type) {
    state.comment_types = comment_type;
  },
  [SET_PENPIC_CLIENT](state, penpicClient) {
    state.penpicClient = penpicClient;
  },
  [SET_DEGREE_LEVEL](state, degree_level) {
    state.degree_level = degree_level;
  },
  [SET_EXPERIENCE_LEVEL](state, experienceLevel) {
    state.experienceLevel = experienceLevel;
  },
  [SET_FILTER](state, filter) {
    state.filter = filter;
  },
  [SET_GROWTH_PLATFORM](state, growth_platform) {
    state.growth_platform = growth_platform;
  },
  [SET_JOB_ROLE_SPECIALTIES](state, job_role_specialties) {
    state.job_role_specialties = job_role_specialties;
  },
  [SET_LOCATION](state, location) {
    state.location = location;
  },
  [SET_PRACTICE](state, practice) {
    state.practice = practice;
  },
  [SET_PRONOUN](state, pronoun) {
    state.pronoun = pronoun;
  },
  [SET_SECTOR](state, sector) {
    state.sector = sector;
  },
  [SET_SKILL](state, skill) {
    state.skill = skill;
  },
  [SET_TECH_SKILL](state, skill) {
    state.techSkill = skill;
  },
  [SET_SOFT_SKILL](state, skill) {
    state.softSkill = skill;
  },
  [SET_ROLE](state, role) {
    state.role = role;
  },
  [SET_CV_REVIEWER_OPEN_SEATS](state, cv_reviewer_open_seats) {
    state.cv_reviewer_open_seats = cv_reviewer_open_seats;
  },
  [SET_USER_ROLE](state, user_role) {
    state.user_role = user_role;
  },
  [SET_PERMISSION](state, permission) {
    state.permission = permission;
  },
  [SET_ROLE_PERMISSION](state, role_permission) {
    state.role_permission = role_permission;
  },
  [SET_SUPPORT](state, support) {
    state.support = support;
  },
  [SET_SUPPORT_DETAIL](state, support_detail) {
    state.support_detail = support_detail;
  },
  [SET_SUPPORT_TYPE](state, support_types) {
    state.support_types = support_types;
  },
  [SET_LOADING](state, loading) {
    state.loading = loading;
  },
  [SET_GREY_SCALE](state, greyScale) {
    state.greyScale = greyScale;
  },
  [SET_CLIENT_CONFIG](state, clientConfig) {
    state.clientConfig = clientConfig;
  },
  [SET_ANONYMOUS](state, anonymous) {
    state.anonymous = anonymous;
  },
  [SET_TIMING_OUT](state) {
    state.timing_out++;
  },
  [SET_PERMISSION_GROUPS](state, groups) {
    state.permission_groups = groups;
  },
  [SET_PERMISSION_GROUPS_DETAIL](state, group) {
    state.permission_groups_detail = group;
  },
  [SET_EDITMODE](state, editmode) {
    state.editmode = editmode;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
